<style lang="less" scoped>
  .header {
    display: flex;
    justify-content: space-between;
    padding-bottom: 24px;
  }
</style>

<template lang="pug">
  .header
    home-button-component(@click.native='handleHomeClick')
    restart-button-component(@click.native='handleRestartClick')
</template>

<script>
import HomeButtonComponent from '@/components/header_home_btn';
import RestartButtonComponent from '@/components/header_restart_btn';

export default {
  methods: {
    handleHomeClick() {
      this.$emit('click-home');
    },
    handleRestartClick() {
      this.$emit('click-restart');
    },
  },
  components: {
    RestartButtonComponent,
    HomeButtonComponent,
  },
};
</script>



// WEBPACK FOOTER //
// src/components/header/home_restart.vue